/* ============================================
   MERCANTE DI PIETRE — Blog FAQ accordion
   File: blog-faq.js (assets)
   Caricato da main-article.liquid con defer.
   ============================================ */

(function () {
  'use strict';

  function init() {
    var triggers = document.querySelectorAll('.mp-faq__trigger');
    if (triggers.length === 0) return;

    triggers.forEach(function (btn) {
      // Evita doppi bind se lo script viene richiamato più volte
      if (btn.dataset.mpFaqBound === '1') return;
      btn.dataset.mpFaqBound = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var item = this.closest('.mp-faq__item');
        var expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', String(!expanded));
        if (item) item.classList.toggle('open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
